import { FC } from 'react';
import { humanizeAge } from './FreshnessPill';
import { StaleBannerProps } from './types';

/**
 * Gold banner shown below the header when `/ingest/status.stale === true`
 * (README §Global layout / app shell). "Refresh now" re-runs the current
 * batch/search fetch (wired by index.tsx via onRefresh).
 */

// gold-100 / gold-200 / gold-700 (README §Design Tokens "Status pills": pale
// fill + deep text) — matches the amber tint used by the stale FreshnessPill.
const GOLD_100 = '#FEF0D9';
const GOLD_200 = '#FBDBA0';
const GOLD_700 = '#B25E09';

const BANNER_STYLE: React.CSSProperties = {
  background: GOLD_100,
  border: `1px solid ${GOLD_200}`,
  color: GOLD_700,
  fontSize: 13,
  padding: '10px 16px',
  borderRadius: 6,
  marginTop: 12,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
};

const MESSAGE_STYLE: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
};

const LINK_BUTTON_STYLE: React.CSSProperties = {
  color: '#E08A14',
  fontWeight: 600,
  cursor: 'pointer',
  textDecoration: 'underline',
  background: 'none',
  border: 'none',
  padding: 0,
  fontSize: 13,
  whiteSpace: 'nowrap',
};

const StaleBanner: FC<StaleBannerProps> = ({ ingest, onRefresh }) => {
  if (!ingest?.stale) return null;

  return (
    <div style={BANNER_STYLE} role="status">
      <span style={MESSAGE_STYLE}>
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
          <path
            d="M8 1.5 1 14h14L8 1.5Z"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinejoin="round"
          />
          <path d="M8 6.25v3.25" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
          <circle cx="8" cy="11.75" r="0.9" fill="currentColor" />
        </svg>
        ~{humanizeAge(ingest.ageSeconds)} old — batch matches may lag recent résumé updates.
      </span>
      <button type="button" style={LINK_BUTTON_STYLE} onClick={onRefresh}>
        Refresh now
      </button>
    </div>
  );
};

export default StaleBanner;
